<template>
<div>
  <div class="tax-team-container">
            <span class="tax-team-text">{{FORM_LABELS.FOR_TAX_TEAM_ONLY}}
              <span class="font-italic">{{FORM_LABELS.DIRECT_INDIRECT_TAX_RECONCILIATION}}</span>
            </span>
  </div>
  <div class="title pt-2">
            <span>
              {{FORM_LABELS.DOC_HEADER_TEXT}}
            </span>
  </div>
  <div class="mb-4 my-2">
    <input
        class="form-control"
        name="formData.docHeaderText"
        v-model="formData.docHeaderText"
        id="formData.docHeaderText"
        autocomplete="nope"
        v-validate="'max:25'"
        data-vv-validate-on="input"
    >
    <show-errors :for-item="'formData.docHeaderText'" :form-errors="errors" :max-length="25" :field-name="'Doc header text'" />
  </div>

  <div class="title pt-2">
            <span>
              {{FORM_LABELS.ASSIGNMENT}}
            </span>
  </div>
  <div class="mb-4 my-2">
    <input
        class="form-control"
        name="formData.assignment"
        v-model="formData.assignment"
        id="formData.assignment"
        autocomplete="nope"
        v-validate="'max:18'"
        data-vv-validate-on="input"
    >
    <show-errors :for-item="'formData.assignment'" :form-errors="errors" :max-length="18" :field-name="'Assignment'" />
  </div>
</div>
</template>

<script>
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";

export default {
  name: "AssignmentAndDocHeaderTextInput",
  props: ['form'],
  mixins: [PaymentFormsMixin],
  computed: {
    formData() {
      return this.$store.getters[this.form]
    }
  }
}
</script>

<style scoped>
.tax-team-container {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #000;
  line-height: 0.1em;
  margin: 40px 0 20px;
}

.tax-team-container .tax-team-text {
  background:#fff;
  padding:0 10px 0 0;
}
</style>